export default __webpack_public_path__ + "static/media/feature-2.77ff9e5b.svg";